import { render, staticRenderFns } from "./CertificateMobile.vue?vue&type=template&id=42765abc&scoped=true&"
import script from "./CertificateMobile.vue?vue&type=script&lang=ts&"
export * from "./CertificateMobile.vue?vue&type=script&lang=ts&"
import style0 from "./CertificateMobile.vue?vue&type=style&index=0&id=42765abc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42765abc",
  null
  
)

export default component.exports